import { render, staticRenderFns } from "./QuestionEdit.vue?vue&type=template&id=d05ad0f6&"
import script from "./QuestionEdit.vue?vue&type=script&lang=ts&"
export * from "./QuestionEdit.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/vsts/work/1/s/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('d05ad0f6')) {
      api.createRecord('d05ad0f6', component.options)
    } else {
      api.reload('d05ad0f6', component.options)
    }
    module.hot.accept("./QuestionEdit.vue?vue&type=template&id=d05ad0f6&", function () {
      api.rerender('d05ad0f6', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/configuration/questions/QuestionEdit.vue"
export default component.exports